export default __webpack_public_path__ + "static/media/Básico-3.333ad143.jpg";